import React from "react";

const EditCaptionIcon = () => {
  return (
    <svg
      width={17}
      height={17}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.83333 14.6667H3.13958L12.1 5.70625L10.7937 4.4L1.83333 13.3604V14.6667ZM0.916667 16.5C0.656944 16.5 0.439236 16.4122 0.263542 16.2365C0.0878472 16.0608 0 15.8431 0 15.5833V13.3604C0 13.116 0.0458333 12.883 0.1375 12.6615C0.229167 12.4399 0.359028 12.2451 0.527083 12.0771L12.1 0.527083C12.2833 0.359028 12.4858 0.229167 12.7073 0.1375C12.9288 0.0458333 13.1618 0 13.4062 0C13.6507 0 13.8875 0.0458333 14.1167 0.1375C14.3458 0.229167 14.5444 0.366667 14.7125 0.55L15.9729 1.83333C16.1562 2.00139 16.2899 2.2 16.374 2.42917C16.458 2.65833 16.5 2.8875 16.5 3.11667C16.5 3.36111 16.458 3.5941 16.374 3.81563C16.2899 4.03715 16.1562 4.23958 15.9729 4.42292L4.42292 15.9729C4.25486 16.141 4.06007 16.2708 3.83854 16.3625C3.61701 16.4542 3.38403 16.5 3.13958 16.5H0.916667ZM11.4354 5.06458L10.7937 4.4L12.1 5.70625L11.4354 5.06458Z"
        fill="white"
      />
    </svg>
  );
};

export default EditCaptionIcon;
